// frontend/src/pages/LoginPage.jsx

import { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Sun } from 'lucide-react';
import { LoginForm } from '../components/Auth/LoginForm';
import { useAuthStore } from '../store/authStore';

export const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();

  // مسیر قبلی (اگر از ProtectedRoute آمده باشد)
  const from = location.state?.from || '/';

  // اگر لاگین است، به صفحه قبلی برو
  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Sun className="w-12 h-12 text-solar-500" />
          <span className="text-3xl font-bold text-gray-900">سولار پلتفرم</span>
        </Link>
      </div>

      <LoginForm />

      <p className="mt-8 text-center text-sm text-gray-600">
        با ورود یا ثبت‌نام،{' '}
        <Link to="/terms" className="text-primary-600 hover:text-primary-500">
          قوانین و مقررات
        </Link>{' '}
        را می‌پذیرم
      </p>
    </div>
  );
};